import React from 'react';
import {Col, Container, Row} from "react-bootstrap";
import {LazyLoadImage} from "react-lazy-load-image-component";
import Img1 from "../../../images/podcast/uber.png";
import Img2 from "../../../images/podcast/n2.jpg";
import Img3 from "../../../images/podcast/paypal.png";



function Mention(props) {
    return (
        <div className="podcast_story p-100">
            <Container className="h-100">
                <Row className="h-100">
                    <Col xs={12} md={12} lg={12} xl={12} xxl={12} className="m-auto text-center">
                        <h5 className="episode_name">
                            Mentioned
                        </h5>
                        <Row className="h-100">
                                <Col xs={12} md={4} lg={3} xl={3} xxl={3}
                                     className="text-center m-auto img_podcast">
                                    <LazyLoadImage
                                        src={Img1}
                                        effect="blur" alt="Image" className="img-fluid"
                                    />
                                </Col>
                            <Col xs={12} md={4} lg={3} xl={3} xxl={3}
                                 className="text-center m-auto img_podcast">
                                <LazyLoadImage
                                    src={Img2}
                                    effect="blur" alt="Image" className="img-fluid"
                                />
                            </Col>
                            <Col xs={12} md={4} lg={3} xl={3} xxl={3}
                                 className="text-center m-auto img_podcast">
                                <LazyLoadImage
                                    src={Img3}
                                    effect="blur" alt="Image" className="img-fluid"
                                />
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default Mention;